import React from 'react'
import Paper from 'material-ui/Paper'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Question from './Question'

const Qa = (props) => (
  <div style={{color: '#6B7C93'}}>
    <div className='flex items-center mb3'>
      <Link to={'/admin/settings'} className='link'>
        <span className='pr2' style={{fontSize: 24, opacity: 0.37}}>
          <FormattedMessage id='mangePlan.settings'/>
        </span>
      </Link>
      <Arrow className='pr2' style={{fill: '#c6ced7'}}/>
      <Link to={'/admin/settings/manage-plans'} className='link'>
        <span className='pr2' style={{fontSize: 24, opacity: 0.37}}>
          <FormattedMessage id='mangePlan.manage'/>
        </span>
      </Link>
      <Arrow className='pr2' style={{fill: '#c6ced7'}}/>
      <span style={{fontSize: 24}}><FormattedMessage id='mangePlan.FAQ'/></span>
    </div>
    <Paper
      className='pa4 overflow-auto'
      style={{height: '80vh', color: '#6B7C93'}}>
      <div
        className='mb4'
        style={{fontSize: 24}}><FormattedMessage id='faq.pricing'/></div>
      <Question
        question={<FormattedMessage id='faq.question1'/>}
        answer={<FormattedMessage id='faq.answer1'/>}/>
      <Question
        question={<FormattedMessage id='faq.question2'/>}
        answer={<FormattedMessage id='faq.answer2'/>}/>
      <Question
        question={<FormattedMessage id='faq.question3'/>}
        answer={<FormattedMessage id='faq.answer3'/>}/>
      <Question
        question={<FormattedMessage id='faq.question4'/>}
        answer={<FormattedMessage id='faq.answer4'/>}/>
      <Question
        question={<FormattedMessage id='faq.question5'/>}
        answer={<FormattedMessage id='faq.answer5'/>}/>
    </Paper>
  </div>
)

export default Qa



// WEBPACK FOOTER //
// ./src/routes/FaQs/FaQs.js